import { LoadablePaint } from '@confluence/loadable';

export const ManagePagesLoader = LoadablePaint({
	name: 'ManagePagesLoader',
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-ManagePages2" */ './ManagePagesV2.tsx'))
			.ManagePagesV2;
	},
});
